export const FORM_ENDPOINT = process.env.REACT_APP_FORM_ENDPOINT;
